import React from "react";
import AthleteScore from "../athlete-scores/athlete-score";
import Modal from "../Modal";

export default function AthleteProfilePreviewModal({
  isOpen,
  athleteId,
  onClose,
}) {
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <AthleteScore
        userId={athleteId}
        showOffers={true}
        showTrackittScore={true}
        showPositionScore={true}
        searchEvent={false}
        showProfile={true}
        showRank={true}
        showLikes={true}
        isolateProfile={true}
      />
    </Modal>
  );
}
